var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "containerBox", staticStyle: { "padding-top": "1.4rem" } },
    [
      _c("newsTopBox", { attrs: { title: "" } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "topBox" },
        [
          _vm.microBannerList.length > 0
            ? _c(
                "Swiper",
                {
                  staticClass: "bannerBox",
                  attrs: { autoPlay: true, interval: "2500", duration: "500" }
                },
                _vm._l(_vm.microBannerList, function(item, index) {
                  return _c("Slide", {
                    key: index,
                    staticClass: "banner",
                    style: {
                      background:
                        "url(" +
                        (_vm.EnvUrl + item.pic) +
                        ") no-repeat center/cover"
                    },
                    on: {
                      click: function($event) {
                        _vm.clickMe(item.picUrl)
                      }
                    }
                  })
                })
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "tabBox" }, [
            _c(
              "div",
              {
                staticClass: "tab",
                on: {
                  click: function($event) {
                    _vm.gotoUsOnline()
                  }
                }
              },
              [
                _c("div", { staticClass: "tIcon t1" }),
                _vm._v("\n        在线疏导\n      ")
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "tab",
                on: {
                  click: function($event) {
                    _vm.telDredge()
                  }
                }
              },
              [
                _c("div", { staticClass: "tIcon t2" }),
                _vm._v("\n        电话疏导\n      ")
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "tab",
                on: {
                  click: function($event) {
                    _vm.gotoCulinarian()
                  }
                }
              },
              [
                _c("div", { staticClass: "tIcon t5" }),
                _vm._v("\n        心理咨询\n      ")
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "tab", on: { click: _vm.gotoMiyou } }, [
              _c("div", { staticClass: "tIcon t4" }),
              _vm._v("\n        AI慧语心理\n      ")
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "fmBox",
          on: {
            click: function($event) {
              _vm.to("music?musicId=" + _vm.musicList[0].musicId)
            }
          }
        },
        [
          _c("div", { staticClass: "fmLeft" }, [
            _vm.musicList.length > 0
              ? _c("div", { staticClass: "fmTitle" }, [
                  _vm._v(
                    "\n        " + _vm._s(_vm.musicList[0].name) + "\n      "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "fmIconBox" }, [_vm._v("倾听 | 疏导")])
          ]),
          _vm._v(" "),
          _vm._m(0)
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "box" },
        [
          _c(
            "div",
            {
              staticClass: "titleBox",
              staticStyle: { "margin-bottom": "0.32rem" }
            },
            [
              _vm._v("\n      情绪健康\n      "),
              _c(
                "div",
                {
                  staticClass: "moreBox",
                  on: {
                    click: function($event) {
                      _vm.to("ask")
                    }
                  }
                },
                [
                  _vm._v("\n        更多\n        "),
                  _c("div", { staticClass: "moreIcon" })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "reducibleList" }, [
            _c(
              "div",
              {
                staticClass: "reducibleItem",
                class: { active: !_vm.bespeakAbled },
                on: {
                  click: function($event) {
                    _vm.changeBespeakAbled(0)
                  }
                }
              },
              [_vm._v("\n        情绪管理师\n      ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "reducibleItem",
                class: { active: _vm.bespeakAbled },
                on: {
                  click: function($event) {
                    _vm.changeBespeakAbled(1)
                  }
                }
              },
              [_vm._v("\n        可预约情绪管理\n      ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "reducibleList" },
            _vm._l(_vm.doctorCampusList, function(item) {
              return _c(
                "div",
                {
                  staticClass: "reducibleItem",
                  class: { active: _vm.campusLocation == item },
                  on: {
                    click: function($event) {
                      _vm.changeCampusLocation(item)
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(item) + "\n      ")]
              )
            })
          ),
          _vm._v(" "),
          _vm._l(_vm.doctorList, function(item) {
            return _c(
              "div",
              {
                staticClass: "expertItem",
                on: {
                  click: function($event) {
                    _vm.to("expertDetail?doctorId=" + item.doctorId)
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "expertLeft",
                  attrs: { src: _vm.EnvUrl + item.doctorWorkPhoto, alt: "" }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "expertRight" }, [
                  _c("div", { staticClass: "nameBox" }, [
                    _c("div", { staticClass: "name" }, [
                      _vm._v(_vm._s(item.doctorName))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "licenseName" }, [
                      _vm._v(_vm._s(item.doctorHospitalLevel))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "good" }, [
                    _vm._v("\n          咨询师介绍："),
                    _c("span", {
                      domProps: { innerHTML: _vm._s(item.doctorProfile) }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "expertTabBox" }, [
                    item.chatDoctorServe.video
                      ? _c("div", { staticClass: "tabItem" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                item.chatDoctorServe.video ? "视频咨询" : ""
                              ) +
                              "\n            "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    item.chatDoctorServe.telephone
                      ? _c("div", { staticClass: "tabItem" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                item.chatDoctorServe.telephone ? "语音咨询" : ""
                              ) +
                              "\n          "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    item.chatDoctorServe.imageText
                      ? _c("div", { staticClass: "tabItem" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                item.chatDoctorServe.imageText ? "图文咨询" : ""
                              ) +
                              "\n            "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    item.chatDoctorServe.offline
                      ? _c("div", { staticClass: "tabItem" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                item.chatDoctorServe.offline ? "线下咨询" : ""
                              ) +
                              "\n          "
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  item.chatDoctorServe.remark && item.chatDoctorServe.offline
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-top": "0.16rem",
                            "font-size": "0.28rem"
                          }
                        },
                        [
                          _vm._v(
                            "\n          线下地址：" +
                              _vm._s(item.chatDoctorServe.remark) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ]
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "box" }, [
        _c("div", { staticClass: "titleBox" }, [
          _vm._v("\n      精品好课\n      "),
          _c(
            "div",
            {
              staticClass: "moreBox",
              on: {
                click: function($event) {
                  _vm.to("courseList")
                }
              }
            },
            [
              _vm._v("\n        更多\n        "),
              _c("div", { staticClass: "moreIcon" })
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "excellentCourses" },
          _vm._l(_vm.microList, function(item) {
            return _c(
              "li",
              {
                on: {
                  click: function($event) {
                    _vm.to("courseDetail?microId=" + item.microId)
                  }
                }
              },
              [
                _c("div", {
                  staticClass: "courseImg",
                  style: {
                    background: "url(" + item.pic + ") no-repeat center/cover"
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "timeBox" }, [
                  _c("span", [_vm._v(_vm._s(item.readCount) + "已看")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm._f("isDuration")(item.duration)) + " ")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "courseTitle" }, [
                  _vm._v(_vm._s(item.name))
                ])
              ]
            )
          })
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "box" }, [
        _c("div", { staticClass: "titleBox" }, [
          _vm._v("\n      推荐好文\n      "),
          _c(
            "div",
            {
              staticClass: "moreBox",
              on: {
                click: function($event) {
                  _vm.to("articleList")
                }
              }
            },
            [
              _vm._v("\n        更多\n        "),
              _c("div", { staticClass: "moreIcon" })
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "article" },
          _vm._l(_vm.articleList, function(item) {
            return _c(
              "li",
              {
                on: {
                  click: function($event) {
                    _vm.to("articleDetail?articleId=" + item.articleId)
                  }
                }
              },
              [
                _c("div", { staticClass: "articleRight" }, [
                  _c("div", { staticClass: "articleTitle" }, [
                    _vm._v(_vm._s(item.title))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "nameBox",
                      staticStyle: { "justify-content": "space-between" }
                    },
                    [
                      _vm._v(
                        "\n            作者：" + _vm._s(item.author) + " "
                      ),
                      _c("span", [_vm._v(_vm._s(item.readCount) + "浏览")])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "articleImg",
                  style: {
                    background:
                      "url(" +
                      _vm.EnvUrl +
                      item.pic +
                      ") no-repeat center/cover"
                  }
                })
              ]
            )
          })
        )
      ]),
      _vm._v(" "),
      _c("footerBox", { attrs: { active: "1" } })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fmRight" }, [
      _c("div", { staticClass: "toIcon" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47323bf2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47323bf2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/index.vue
// module id = null
// module chunks = 